/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index';

let exports = {};

// 获取公司角色列表
exports.getServicerComRoleList = function (params, callback) {// 获取公司角色
    api.post('/servicer/authx/com/role/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 查询机构岗位的列表
exports.getServicerComRolePageList = function (data, callback) {
    api.post('/servicer/authx/com/role/page/list/get')
        .data(data)
        .done(callback)
        .go();
};

exports.getServicerComRoleListByBizUnitId = function (params, callback) {// 获取公司角色
    api.post('/servicer/authx/com/role/list/get/by/bizUnitId')
    .data(params)
    .done(callback)
    .go();
};

// 获取公司角色
exports.getServicerComRole = function (params, callback) {// 获取公司角色
    api.get('/servicer/authx/com/role/get')
    .params(params)
    .done(callback)
    .go();
};
// 保存公司角色
exports.saveServicerComRole = function (params, callback) {// 保存公司角色
    api.post('/servicer/authx/com/role/save/do')
    .data(params)
    .done(callback)
    .go();
};
// 更新公司角色
exports.updateServicerComRole = function (params, callback) {// 更新角色
    api.post('/servicer/authx/com/role/update/do')
    .data(params)
    .done(callback)
    .go();
};
// 排序
exports.moveServicerComRoleSeq = function (params, callback) {// 上下移条目
    api.post('/servicer/authx/com/role/seq/move/do')
    .data(params)
    .done(callback)
    .go();
};
// 启、禁用-公司岗位
exports.updateServicerComRoleForDisabled = function (data, callback) {
    api.post('/servicer/authx/com/role/update/disabled/do')
    .data(data)
    .done(callback)
    .go();
};
// 删除角色
exports.deleteServicerComRole = function (data, callback) {
    api.post('/servicer/authx/com/role/delete/do')
    .data(data)
    .done(callback)
    .go();
};
exports.getServicerComRoleRescRescIdsByRoleId = function (params, callback) {// 获取系统资源列表（带拥有标记）
    api.post('/servicer/authx/com/role/resc/rescIds/get/by/roleId')
    .data(params)
    .done(callback)
    .go();
};
// 根据uk获取角色资源
exports.getServicerComRoleRescByRoleIdAndRescId = function (params, callback) {// 获取系统资源列表（带拥有标记）
    api.post('/servicer/authx/com/role/resc/get/by/roleId/and/rescId')
    .data(params)
    .done(callback)
    .go();
};
// 修改角色资源
exports.updateServicerComRoleRescs = function (params, callback) {// 保存公司角色资源关系
    api.post('/servicer/authx/com/role/resc/update/do')
    .data(params)
    .done(callback)
    .go();
};
// 保存角色资源
exports.saveServicerComRoleRescs = function (params, callback) {// 保存公司角色资源
    api.post('/servicer/authx/com/role/rescs/save/do')
    .data(params)
    .done(callback)
    .go();
};
// 获取人员角色列表
exports.getServicerStaffRoleList = function (params, callback) {// 获取公司人员角色列表
    api.post('/servicer/authx/staff/role/list/get')
    .data(params)
    .done(callback)
    .go();
};
// 替换人员角色
exports.replaceServicerStaffRole = function (params, callback) {// 替换公司人员角色
    api.post('/servicer/authx/staff/role/replace/do')
    .data(params)
    .done(callback)
    .go();
};
// 替换人员角色条件校验
exports.examineStaffRoleChangeCondition = function (data, callback) {// 替换公司人员角色条件校验
    api.post('/servicer/authx/staff/role/change/condition/examine/do')
    .data(data)
    .done(callback)
    .go();
};

// 删除角色资源
exports.deleteServicerComRoleRescByComIdAndRoleIdAndTypeAndScope = function (params, callback) {// 批量保存公司角色资源
    api.post('/servicer/authx/com/role/resc/delete/do/by/filter')
    .data(params)
    .done(callback)
    .go();
};

// =============================================== 业务设置 ==================================================
// =============
// 根据岗位id获取岗位_商品分类catIds
exports.getServicerComRoleGoodsCatCatIdsByRoleId = function (params, callback) {
    api.post('/servicer/authx/com/role/goods/cat/catIds/get')
    .data(params)
    .done(callback)
    .go();
};
// 根据唯一件获取岗位_商品分类列表
exports.getServicerComRoleGoodsCatByUk = function (params, callback) {
    api.post('/servicer/authx/com/role/goods/cat/get/by/uk')
    .data(params)
    .done(callback)
    .go();
};
// 获取岗位_商品分类列表
exports.getServicerComRoleGoodsCatList = function (params, callback) {
    api.post('/servicer/authx/com/role/goods/cat/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 保存岗位_商品分类列表
exports.saveServicerComRoleGoodsCat = function (params, callback) {
    api.post('/servicer/authx/com/role/goods/cats/save/do')
    .data(params)
    .done(callback)
    .go();
};

// =============

// 根据岗位id获取岗位_服务分类catIds
exports.getServicerComRoleServcCatCatIdsByRoleId = function (params, callback) {
    api.post('/servicer/authx/com/role/servc/cat/catIds/get')
    .data(params)
    .done(callback)
    .go();
};
// 根据唯一件获取岗位_服务分类列表
exports.getServicerComRoleServcCatByUk = function (params, callback) {
    api.post('/servicer/authx/com/role/servc/cat/get/by/uk')
    .data(params)
    .done(callback)
    .go();
};
// 获取岗位_服务分类列表
exports.getServicerComRoleServcCatList = function (params, callback) {
    api.post('/servicer/authx/com/role/servc/cat/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 保存岗位_服务分类列表
exports.saveServicerComRoleServcCat = function (params, callback) {
    api.post('/servicer/authx/com/role/servc/cats/save/do')
    .data(params)
    .done(callback)
    .go();
};

// =============
// 根据岗位id获取岗位_机构comIds
exports.getServicerComRoleOrgComIds = function (params, callback) {
    api.post('/servicer/authx/com/role/org/comIds/get')
    .data(params)
    .done(callback)
    .go();
};
// 根据唯一件获取岗位_机构列表
exports.getServicerComRoleOrgByUk = function (params, callback) {
    api.post('/servicer/authx/com/role/org/get/by/uk')
    .data(params)
    .done(callback)
    .go();
};
// 获取岗位_机构列表
exports.getServicerComRoleOrgList = function (params, callback) {
    api.post('/servicer/authx/com/role/org/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 保存岗位_机构列表
exports.saveServicerComRoleOrg = function (params, callback) {
    api.post('/servicer/authx/com/role/orgs/save/do')
    .data(params)
    .done(callback)
    .go();
};

// =============
// 获取岗位_地区列表
exports.getServicerComRoleRegionList = function (params, callback) {
    api.post('/servicer/authx/com/role/region/list/get')
    .data(params)
    .done(callback)
    .go();
};
// 保存岗位_地区列表
exports.saveServicerComRoleRegion = function (params, callback) {
    api.post('/servicer/authx/com/role/regions/save/do')
    .data(params)
    .done(callback)
    .go();
};

// =============
// 获取岗位_行业类型ids
exports.getServicerComRoleIndustyTypeTypeIdsByRoleId = function (params, callback) {
    api.post('/servicer/authx/com/role/industy/type/typeIds/get/by/roleId')
    .data(params)
    .done(callback)
    .go();
};
// 保存岗位_行业类型列表
exports.saveServicerComRoleIndustyTypes = function (params, callback) {
    api.post('/servicer/authx/com/role/industy/types/save/do')
    .data(params)
    .done(callback)
    .go();
};
// 更新岗位_手机APP(固定)角色
exports.updateServicerComRoleMobAppRole = function (data, callback) {
    api.post('/servicer/authx/com/role/mob/app/role/update/do')
    .data(data)
    .done(callback)
    .go();
};

// 清除岗位_手机APP(固定)角色
exports.updateServicerComRoleMobAppRoleForClear = function (data, callback) {
    api.post('/servicer/authx/com/role/mob/app/role/update/for/clear/do')
    .data(data)
    .done(callback)
    .go();
};

//【手机App（固定）角色】关联资源-获取角色已关联的资源操作(回显)
exports.getMobAppRoleRescListForOwn = function (data, callback) {
    api.post('/servicer/authx/mob/role/resc/list/for/own')
    .data(data)
    .done(callback)
    .go()
};

// 【手机App（固定）角色】关联资源-保存角色关联资源操作
exports.saveMobAppRoleRescAndAction = function (data, callback) {
    api.post('/servicer/authx/mob/role/resc/action/save/do')
    .data(data)
    .done(callback)
    .go();
};

// 保存服务接单消息订阅
exports.saveWorkAssignMsgSubscr = function (data, callback) {
    api.post('/servicer/authx/work/assign/msg/subscr/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 取消服务接单消息订阅
exports.cancelWorkAssignMsgSubscr = function (params, callback) {
    api.post('/servicer/authx/work/assign/msg/subscr/delete/do')
    .params(params)
    .done(callback)
    .go();
};
// 取消服务接单消息订阅
exports.getServicerShopIdListByUserId = function (params, callback) {
    api.get('/servicer/authx/servicerShopId/list/get/userId')
    .params(params)
    .done(callback)
    .go();
};

// 保存服务商员工岗位(批量)
exports.saveServicerStaffRoleBatch = function (data, callback) {
    api.post('/servicer/authx/staff/role/batch/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 获取公司人员角色列表根据userId
exports.getServicerStaffRoleDtoList = function (data, callback) {
    api.get('/servicer/authx/staff/role/dto/list/get/by/userId')
    .params(data)
    .done(callback)
    .go();
};
// 公司岗位关联/取消关联商户模板岗位
exports.updateServicerComRoleContactTpl = function (data, callback) {
    api.post('/servicer/authx/com/role/contact/tpl/do')
    .data(data)
    .done(callback)
    .go();
};
// 为公司角色关联人员
exports.doSrelevStaffsForComRole = function (params, callback) {// 为公司角色关联人员
    api.post('/servicer/authx/staff/role/srelev/do')
    .data(params)
    .done(callback)
    .go();
};

// 根据关联商户岗位模版id查询岗位列表
exports.getServicerComRoleBySrcTplId = function (data, callback) {
    api.get('/servicer/authx/com/role/list/list/get/by/srcTplId')
    .params(data)
    .done(callback)
    .go();
};
// 根据关联商户岗位二维码
exports.getServicerComRoleQrCodeUrl = function (params, callback) {
    api.post('/servicer/authx/com/role/qrCode/url/get')
    .data(params)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/servicerAuthx.js
// module id = 32
// module chunks = 1